module.exports = __webpack_public_path__ + "img/sdg_es_(5).c70b1141.png";